export interface ShowType {
  label: string;
  filterStatus: boolean;
}

/**
 * Filter folder content by file type.
 * When filterStatus is true, that type is hidden.
 */
export function filterByType<T extends { type?: string; itemtype?: string }>(
  list: T[],
  showTypes: ShowType[],
): T[] {
  let result = list;
  for (const typeObj of showTypes) {
    if (!typeObj.filterStatus) continue;
    if (typeObj.label === 'folder' || typeObj.label === 'project') {
      result = result.filter((item) => !item.itemtype || item.itemtype !== typeObj.label);
    } else {
      result = result.filter((item) => !item.type || item.type !== typeObj.label);
    }
  }
  return result;
}
